export default {
  velt: {
    openPanel: 'Maak kommentaarpaneel oop',
    closePanel: 'Maak kommentaarpaneel toe',
    panel: 'Kommentaarpaneel',
    tabs: 'Kommentaarpaneel-oortjies',
    comments: 'Kommentaar',
    settings: 'Instellings & Magtigings',
    dragOrTapComment: 'Sleep om kommentaar by te voeg, of tik om kommentaar te sien',
    assignComment: 'Ken kommentaar toe',
    markAsUnread: 'Merk as ongelees',
    markAsRead: 'Merk as gelees',
    unsubscribe: 'Teken uit',
    subscribe: 'Teken in',
    deleteThread: 'Vee draad uit',
    editComment: 'Wysig kommentaar',
    emptyPlaceholder: 'Gee terugvoer, vra \'n vraag of los \'n nota vir jou spanlede',
    searchPlaceholder: 'Soek kommentaar',
    commentPlaceholder: 'Lewer kommentaar op {page}',
    replyPlaceholder: 'Antwoord....',
    filterPages: 'Bladsye',
    filterAuthor: 'Outeur',
    filterTagged: 'Gemerk',
    statusOpen: 'Oop',
    statusResolved: 'Opgelos',
    anonymous: 'Anoniem',
    settingsPanel: {
      title: 'Wie kan kommentaar lewer?',
      everyoneLabel: 'Almal',
      restrictedLabel: 'Slegs genooide medewerkers',
      emailsLabel: 'E-posse',
      emailsPlaceholder: 'Voeg \'n e-pos by en druk enter',
    },
  },
}
